import { alpha } from '@mui/material/styles';

import type { Styles } from 'src/theme/themes';

export const styles = {
  root: (theme) => ({
    '&& .MuiTreeItem-content': {
      '&:hover, &.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
        // important is used to prevent this style from being overridden by other styles using the same selector
        backgroundColor: `${alpha(theme.colors.primary[50], 0.8)}!important`,
      },
    },
  }),
} satisfies Styles;
